import * as actionTypes from "./actionTypes";

export const getAllTimeline = (allTimeline, totalTimeline) => {
  return {
    type: actionTypes.GET_ALL_TIMELINE,
    timeline: allTimeline,
    total: totalTimeline,
  };
};

export const getAllSounds = (sounds) => {
  return {
    type: actionTypes.GET_SOUNDS,
    sounds: sounds
  }
}

export const getAllAvatars = (avatars) => {
  return {
    type: actionTypes.GET_AVATARS,
    avatars: avatars
  }
}

export const updatePost = (singlePost) => {
  return {
    type: actionTypes.UPDATE_POST,
    post: singlePost,
  };
};

export const createPost = (singlePost) => {
  return {
    type: actionTypes.CREATE_POST,
    post: singlePost,
  };
};

export const createPostEnd = (singlePost) => {
  return {
    type: actionTypes.CREATE_POST_END,
    post: singlePost,
  };
};

export const deletePost = (singlePost) => {
  return {
    type: actionTypes.DELETE_POST,
    post: singlePost,
  };
};

export const updateSinglePost = (singlePost) => {
  return {
    type: actionTypes.UPDATE_SINGLE_POST,
    post: singlePost,
  };
};

export const publishPost = (singlePost) => {
  return {
    type: actionTypes.PUBLISH_POST,
    post: singlePost,
  };
};

export const setLoader = (loaderValue) => {
  return {
    type: actionTypes.SET_LOADER,
    loaderValue: loaderValue,
  };
};

export const pageIncreament = () => {
  return {
    type: actionTypes.PAGE_INCREAMENT,
  };
};

export const clearAll = () => {
  return {
    type: actionTypes.CLEAR_ALL,
  };
};

export const getSinglePost = (myPost) => {
  return {
    type: actionTypes.GET_SINGLE_POST,
    post: myPost,
  };
};

export const clearSinglePost = () => {
  return {
    type: actionTypes.CLEAR_SINGLE_POST,
  };
};

export const getTimeLineVideos = (videos, category) => {
  if (category === "intro")
    return {
      type: actionTypes.GET_TIMELINE_INTRO_VIDEOS,
      videos,
    };
  if (category === "outro")
    return {
      type: actionTypes.GET_TIMELINE_OUTRO_VIDEOS,
      videos,
    };
};

export const getLatestRecognition = (latestRecognition) => {
  return {
    type: actionTypes.GET_LATEST_RECOGNITION,
    latestRecognition,
  };
};

export const getTimeLineMessageTemplates = (messages) => {
  return {
    type: actionTypes.GET_TIMELINE_MESSAGE_TEMPLATES,
    messages,
  };
};
